export const factories = [
    'Asus', 'Acer', 'Apple', 'HP', 'Lenovo', 'MSI', 'Dell', 'Gigabyte', 'Huawei', 'Masstel', 'VAIO'
  ];
  
  export const priceRanges = [
    'Dưới 10 triệu',
    'Từ 10 - 15 triệu',
    'Từ 15 - 20 triệu',
    'Từ 20 - 25 triệu',
    'Từ 25 - 30 triệu',
    'Trên 30 triệu'
  ];
  
  export const demands = [
    'Gaming - Đồ họa', 'Sinh viên - Văn phòng', 'Mỏng nhẹ', 'Doanh nhân', 'AI'
  ];
  
  export const screenSizes = [
    'Dưới 14 inch', 'Từ 14 - 15 inch', 'Từ 15 - 17 inch', 'Trên 17 inch'
  ];
  
  export const cpus = [
    'Apple M4 series', 'Apple M3 series', 'Apple M2 series', 'Apple M1 series',
    'Intel Core Ultra', 'Intel Core i9', 'Intel Core i7', 'Intel Core i5', 'Intel Core i3', 'Intel Celeron',
    'AMD Ryzen 9', 'AMD Ryzen 7', 'AMD Ryzen 5'
  ];
  
  export const rams = [
    '4GB',     '8GB',     '12GB',    '16GB',
    '18GB',    '24GB',    '36GB',    '32GB',
    '48GB',    '64GB', 
  ];
  
  export const roms = [
    'SSD 2TB', 'SSD 1TB', 'SSD 512GB', 'SSD 256GB', 'SSD 128GB'
  ];
  
  export const refreshRates = [
    'Dưới 100Hz', 'Từ 100 đến 144Hz', 'Trên 144Hz'
  ];
  
  export const sortOptions = [
    { value: 'default', label: 'Nổi bật' },
    { value: 'price_asc', label: 'Giá tăng dần' },
    { value: 'price_desc', label: 'Giá giảm dần' },
    { value: 'name_asc', label: 'Tên A-Z' },
    { value: 'name_desc', label: 'Tên Z-A' },
    { value: 'newest', label: 'Mới nhất' }
  ];